import { PhoneImage } from "./insider-access/phone-image"
import { InsiderContent } from "./insider-access/content"

export function InsiderAccessSection() {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col-reverse pt-8 md:flex-row md:justify-between md:gap-4">
      <div className="flex flex-[3] pl-1 pr-1 md:pr-0">
        <PhoneImage />
      </div>
      <div className="flex flex-[2] px-8 md:px-0 md:pr-8">
        <InsiderContent />
      </div>
    </div>
  )
}
